import {
  IconApps,
  IconCompass,
  IconDashboard,
  IconDesktop,
  IconFile,
  IconMenu,
  IconMindMapping,
  IconNotification,
  IconStorage,
} from '@arco-design/web-react/icon';

import { GROUPS } from '@/service/groups';

export const systemMenu = [
  {
    // 系统设置
    title: 'systemSettingsMode',
    icon: 'icon-yunyingguanli1',
    children: [
      {
        title: 'largeScreen',
        path: '/system/large-screen',
        icon: 'icon-keshihuadaping',
        permissionVisibleWithParent: true,
        viewAuth: [GROUPS.confcenter, 'kv', 'get'],
      },
      // 运营中心：门户管理 / 产品管理 / 运营策略 / 充值管理
      {
        title: 'operationsGovernance',
        icon: 'icon-yunyingguanli1',
        children: [
          {
            title: 'portalManagement',
            icon: 'icon-gailan',
            children: [
              {
                title: 'carouselManagement',
                path: '/system/carousels',
                icon: 'icon-lunbotu',
                viewAuth: [GROUPS.ophub, 'carousels', 'list'],
              },
              {
                // 原「产品目录」，展示为导航菜单
                title: 'productCatalogue',
                path: '/system/product-catalogue',
                icon: 'icon-chanpinleibie',
                viewAuth: ['ophub.stack.io', 'product-catalogues', 'list'],
              },
              {
                // 原「系统配置 → 平台设置」，路由用 platform-settings 避免与登录配置语义混淆
                title: 'loginSettings',
                path: '/system/platform-settings',
                icon: 'icon-Setting',
                viewAuth: ['*', '*', '*'],
              },
            ],
          },
          {
            title: 'productManagement',
            icon: 'icon-a-chanpinguanli1',
            children: [
              {
                title: 'productTypes',
                path: '/system/product-types',
                icon: 'icon-a-chanpinleibie1',
                viewAuth: [GROUPS.ophub, 'product-types', 'list'],
              },
              {
                title: 'productList',
                path: '/system/products',
                icon: 'icon-a-chanpinguanli1',
                viewAuth: [GROUPS.ophub, 'products', 'list'],
              },
            ],
          },
          {
            title: 'operationStrategy',
            icon: 'icon-yunyingguanli1',
            children: [
              {
                title: 'noticeList',
                path: '/system/notice',
                icon: 'icon-shuoming',
                viewAuth: [GROUPS.notice, 'notices', 'list'],
              },
              {
                title: 'couponStrategy',
                path: '/system/coupon-strategy',
                icon: 'icon-youhuijuan',
                viewAuth: [GROUPS.ophub, 'coupons', 'list'],
              },
            ],
          },
          {
            title: 'rechargeManagement',
            icon: 'icon-buchongjifei',
            children: [
              {
                title: 'rechargeApply',
                path: '/system/recharge',
                icon: 'icon-buchongjifei',
                viewAuth: [GROUPS.ophub, 'recharge-requests', 'list'],
              },
              {
                title: 'sysAccount',
                path: '/system/account',
                icon: 'icon-yunyingguanli1',
                viewAuth: [GROUPS.ophub, 'system-config', 'list'],
              },
            ],
          },
        ],
      },
      // 报表中心
      {
        title: 'reportCenter',
        icon: IconDashboard,
        children: [
          {
            title: 'reportOverview',
            path: '/system/report-center/overview',
            icon: IconCompass,
            viewAuth: [GROUPS.datareport, 'reports/overview', 'get'],
          },
          {
            title: 'reportCompute',
            path: '/system/report-center/compute',
            icon: IconDesktop,
            viewAuth: [GROUPS.datareport, 'reports/compute', 'get'],
          },
          {
            title: 'reportModel',
            path: '/system/report-center/model',
            icon: IconMindMapping,
            viewAuth: [GROUPS.datareport, 'reports/model', 'get'],
          },
          {
            title: 'reportApp',
            path: '/system/report-center/app',
            icon: IconApps,
            viewAuth: [GROUPS.datareport, 'reports/app', 'get'],
          },
          {
            title: 'reportOps',
            path: '/system/report-center/ops',
            icon: IconNotification,
            viewAuth: [GROUPS.datareport, 'reports/ops', 'get'],
          },
          {
            title: 'reportBusiness',
            path: '/system/report-center/business',
            icon: IconFile,
            viewAuth: [GROUPS.datareport, 'reports/business', 'get'],
          },
          {
            title: 'reportResource',
            path: '/system/report-center/resource',
            icon: IconStorage,
            viewAuth: [GROUPS.datareport, 'reports/resource', 'get'],
          },
        ],
      },
      {
        title: 'systemResource',
        path: '/system/resource',
        icon: 'icon-ziyuanguanli',
        // 视觉上提升唯一子项，静态层级保留以兼容既有后台菜单白名单 key。
        promoteChildren: true,
        children: [
          {
            title: 'dataCenterManagement',
            path: '/system/datacenters',
            icon: 'icon-jisuanjiqun',
            viewAuth: [GROUPS.datacenter, 'datacenters', 'list'],
          },
        ],
      },
      // 权限管理
      {
        title: 'IAM',
        icon: 'icon-quanxianguanli',
        children: [
          {
            title: 'tenant',
            path: '/system/tenants',
            icon: 'icon-zuhuguanli',
            viewAuth: [GROUPS.workspace, 'ws', 'list'],
          },
          {
            title: 'user',
            path: '/system/users',
            icon: 'icon-Team',
            viewAuth: [GROUPS.iam, 'users', 'list'],
          },
          {
            title: 'rbac',
            path: '/system/roles',
            icon: 'icon-pingtaijiaose',
            viewAuth: [GROUPS.iam, 'roles', 'list'],
          },
          /** 审计菜单权限 */
          {
            title: 'audit',
            path: '/system/audit',
            icon: 'icon-Outline',
            viewAuth: [GROUPS.iam, 'audits', 'list'],
          },
        ],
      },
      // 系统设置-仅管理员可见（平台设置已迁至运营中心 → 门户管理）
      {
        title: 'systemSettings',
        icon: 'icon-Setting',
        // 该分组仅管理员可访问，不参与普通角色的权限分配。
        permissionConfigHidden: true,
        children: [
          {
            title: 'systemMenus',
            path: '/system/menus',
            icon: IconMenu,
            viewAuth: ['*', '*', '*'],
          },
        ],
      },
    ],
  },
];
